// extracted by mini-css-extract-plugin
export default {"container":"wJ48X0UJzoCJwNLqYlmL","pictureContainer":"CAi10GfxZ8o_NMOl77xV","picture":"TJI7KdUd_KNkw7BmmbEw","name":"CLLhP4rnwQ1rp5mQkKzt","location":"J_lntGhYyHOW6Qo03r3x"};